import { render, staticRenderFns } from "./AwardedActions.vue?vue&type=template&id=486d4390&scoped=true&"
import script from "./AwardedActions.vue?vue&type=script&lang=js&"
export * from "./AwardedActions.vue?vue&type=script&lang=js&"
import style0 from "./AwardedActions.vue?vue&type=style&index=0&id=486d4390&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486d4390",
  null
  
)

export default component.exports